import { render, staticRenderFns } from "./messageTemplateDetailPhone.vue?vue&type=template&id=6fc2e454"
import script from "./messageTemplateDetailPhone.vue?vue&type=script&lang=js"
export * from "./messageTemplateDetailPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports